import { Factory } from "fishery";
import { AssociatePaymentPrefMutationTypeEnum } from "../components/PaymentPrefConsolidated/Context/enums";
import type { ChangeRequestPayloadsInput } from "../components/PaymentPrefConsolidated/Components/PaymentPrefConfirmation/utils";

export const changeRequestPayloadInputFactory: Factory<ChangeRequestPayloadsInput> =
  Factory.define<ChangeRequestPayloadsInput>(() => {
    return {
      associatePaymentPref:
        AssociatePaymentPrefMutationTypeEnum.PositionsWithoutPaymentPrefOfAccount,
      arenaId: "1",
      targetPaymentPrefId: "2",
      accountId: "3",
      sourcePaymentPrefId: undefined,
      positionId: undefined,
      bypassCheckForAcceptedPaymentMethods: false,
      accountName: undefined,
    };
  });
